import React from "react";
import "./Button.scss";
import PropTypes from "prop-types";

export const Button = ({
  className,
  color,
  iconBefore,
  iconAfter,
  submitting,
  onClick,
  isDisabled,
  ...props
}) => {
  const classes = () => {
    let classes = ["button_basic"];
    if (color) {
      classes.push("button-" + color);
    }
    if (iconAfter) {
      classes.push("button_with-icon-after");
    }
    if (iconBefore) {
      classes.push("button_with-icon-before");
    }
    return classes;
  };

  const renderIcon = (icon) => {
    if (!icon) return null;

    // If it's a React element (like Material UI icons)
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, {
        className: `button-icon ${icon.props.className || ""}`,
        style: {
          width: "18px",
          height: "18px",
          display: "inline-block",
          verticalAlign: "middle",
          lineHeight: "1",
          ...icon.props.style,
        },
      });
    }

    // If it's a string (URL to image)
    if (typeof icon === "string") {
      return <img src={icon} alt="" className="button-icon" />;
    }

    // If it's a component class/function
    if (typeof icon === "function") {
      const IconComponent = icon;
      return (
        <IconComponent
          className="button-icon"
          style={{
            width: "18px",
            height: "18px",
            display: "inline-block",
            verticalAlign: "middle",
            lineHeight: "1",
          }}
        />
      );
    }

    return null;
  };

  return (
    <button
      {...props}
      className={classes().join(" ") + " " + className}
      disabled={submitting || isDisabled}
      onClick={onClick}
    >
      {iconBefore && (
        <span className="button-icon-before">{renderIcon(iconBefore)}</span>
      )}

      <span className="title">{props.children}</span>

      {iconAfter && (
        <span className="button-icon-after">{renderIcon(iconAfter)}</span>
      )}
    </button>
  );
};

Button.defaultProps = {
  className: "button-default",
  iconBefore: null,
  iconAfter: null,
  submitting: false,
  color: null,
  onClick: () => {
    console.log("Click");
  },
};

Button.propTypes = {
  color: PropTypes.string,
  iconBefore: PropTypes.oneOfType([
    PropTypes.string, // URL to image
    PropTypes.func, // React component
    PropTypes.element, // React element
  ]),
  iconAfter: PropTypes.oneOfType([
    PropTypes.string, // URL to image
    PropTypes.func, // React component
    PropTypes.element, // React element
  ]),
  submitting: PropTypes.number,
  onClick: PropTypes.func,
};
